import PropTypes from 'prop-types';
import { Title } from '~/components';
import styles from './ReviewIntro.scss';

export const ReviewIntro = ({
  reviewIntroConfig: { title, description, buildDescription } = {
    title: 'Review',
    description: 'Review your details before you complete your appointment booking',
    buildDescription: null,
  },
  shopName = '',
}) => (
  <div className={styles.ReviewIntroWrapper}>
    <Title id="title" className={styles.Title}>
      {title}
    </Title>
    <div className={styles.Review__intro} data-testid="ReviewIntro">
      <p>{buildDescription ? buildDescription(shopName) : description}</p>
    </div>
  </div>
);

ReviewIntro.displayName = 'ReviewIntro';

ReviewIntro.propTypes = {
  reviewIntroConfig: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    buildDescription: PropTypes.func,
  }),
  shopName: PropTypes.string,
};
